module.exports = __webpack_public_path__ + "media/images/frontend/lamberet/ver-separator-8b1101d29a8a070d75484660e5f4c97f.png";